module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_1-025b278ff15efd23d7c8a938c8d634ab.svg";